export default {"src":"/_next/static/media/ON.9708578e.svg","height":18,"width":18};